import ClassroomSelector from './classroom-selector.vue';
import ClassroomCheckingSelector from './classroom-checking-selector.vue';

export default {
  install(application) {
    application.component('yx-classroom-selector', ClassroomSelector);
    application.component('yx-classroom-checking-selector', ClassroomCheckingSelector);
  },
};
